/* The home page's artist index: opening one artist's row closes the others.

   One open row at a time on purpose. The rows are tall — a name at display
   size over four works — so several open at once would bury the rest of the
   list and the page below it. */
(function () {
  function bind(root) {
    var buttons = root.querySelectorAll('.coart-artist-index__open');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var row = button.closest('.coart-artist-index__row');
        var was = row.classList.contains('is-open');

        buttons.forEach(function (other) {
          other.closest('.coart-artist-index__row').classList.remove('is-open');
          other.setAttribute('aria-expanded', 'false');
        });

        /* Clicking the open row closes it, which is why the state is read
           before every row is closed above. */
        if (!was) {
          row.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  document.querySelectorAll('.coart-artist-index').forEach(bind);

  /* The theme editor swaps the section's markup in place, and script tags
     inserted that way never run again, so the new rows arrive unbound. */
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.coart-artist-index').forEach(bind);
  });
})();
